//https://app.servicios.gt/api/admin/dte/history?companyId=2841&endDate=1718647130544&onlyErrors=true&startDate=1717221600000
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AccountResponse } from '../models/account.model';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { FileDetailResponse } from '../models/admin.model';

@Injectable({
	providedIn: 'root'
})
export class AdminDTEService {
	private URL = environment.api + "api/admin";
	constructor(
		private http: HttpClient,
	) { }

	getHistoryDTE(company, startDate, endDate, onlyErrors, isPartner = false) {
		var searchedCompany = company;
		var params = null;
		if (company == null && isPartner) {
			return;
		}
		if (company == null) {
			searchedCompany = 809;
			params = {
				endDate: endDate,
				startDate: startDate,
				onlyErrors: onlyErrors
			}
		} else {
			searchedCompany = company;
			params = {
				companyId: company,
				endDate: endDate,
				startDate: startDate,
				onlyErrors: onlyErrors
			}
		}
		const headerDict = {
			"inin-company": searchedCompany
		}
		const requestOptions = {
			headers: new HttpHeaders(headerDict),
			params: params
		};
		return this.http.get(this.URL + `/dte/history` + (isPartner ? 'Admin' : ''), requestOptions);
	}

	previewFile(file) {
		const formData = new FormData();
		formData.append('file_type', 'GENERAL');
		formData.append('file', file);
		return this.http.post<any>(this.URL + '/dte/preview', formData);
	}

	getFile(fileName: string) {
		return this.http.get(this.URL + "/dte", {
			params: {
				fileName: fileName,
				fileType: "GENERAL"
			}
		});
	}

	processSelected(file: FileDetailResponse, onlyAnulated) {
		return this.http.post(this.URL + "/dte/" + onlyAnulated, file);
	}

	processFile(file, onlyAnulated) {
		const formData = new FormData();
		formData.append('file_type', 'GENERAL');
		formData.append('file', file);
		if(onlyAnulated == false){
			return this.http.post(this.URL + '/dte/processaws/' + onlyAnulated, formData);
		}else{
			return this.http.post(this.URL + '/dte/process/' + onlyAnulated, formData);
		}
	}
}